import { makeStyles } from '@mui/styles'
import Colors from 'utils/Colors'

const styles = makeStyles(() => ({
  root: {
    width: '100%',
  },

  carouselImage: {
    maxHeight: '55vh',
    minHeight: '55vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'relative',
    backgroundColor: Colors.primaryColor,
    '& > img': {
      maxHeight: '55vh',
      maxWidth: '100%',
    },
  },
  description: {
    padding: '1rem 2rem',
    position: 'absolute',
    bottom: 0,
    left: 0,
    color: Colors.white,
    width: '100%',
    backgroundColor: '#21212177', 
    '& > p':{
      textTransform: 'capitalize',
      '& > span': {
        fontWeight: 600,
      },
    },
  },
}))

export default styles
